import type { AppLocale } from "@/config/app-locale";
import type { TenantCode } from "@/config/tenants";

export interface TenantLogoAsset {
  readonly src: string;
  readonly alt: string;
}

export type TenantLogoSet = Readonly<Record<AppLocale, TenantLogoAsset>>;

export const tenantLogoConfigurations: Partial<Record<TenantCode, TenantLogoSet>> = {
  "12connex": {
    en: {
      src: "/logo/Logo CV Builder.jpg",
      alt: "CVBuilder",
    },
    fr: {
      src: "/logo/Logo CV Builder.jpg",
      alt: "CVBuilder",
    },
  },
};

export function tenantLogoFor(tenant: TenantCode, locale: AppLocale): TenantLogoAsset | null {
  return tenantLogoConfigurations[tenant]?.[locale] ?? null;
}
